// ** Dropdowns Imports
// import IntlDropdown from "./IntlDropdown";
import UserDropdown from "./UserDropdown";
// import NavbarSearch from "./NavbarSearch";
import NotificationDropdown from "./NotificationDropdown";
import Announcement from "./Announcement";

// ** Third Party Components
// import { Sun, Moon } from "react-feather";

// ** Reactstrap Imports

// icon import
import keyIcon from "../../../../assets/images/logo/keyIcon.svg";

import {
    NavItem,
    //  NavLink
} from "reactstrap";

const NavbarUser = (props) => {
    // ** Props
    const { isMobile, toggleHandler } = props;

    // ** Function to toggle Theme (Light/Dark)
    // const ThemeToggler = () => {
    //     if (skin === "dark") {
    //         return <Sun className="ficon" onClick={() => setSkin("light")} />;
    //     } else {
    //         return <Moon className="ficon" onClick={() => setSkin("dark")} />;
    //     }
    // };

    return (
        <ul className="nav navbar-nav align-items-center ms-auto">
            {/* <IntlDropdown /> */}
            <NavItem className="d-none d-lg-block">
                {/* <NavLink className='nav-link-style'>
          <ThemeToggler />
        </NavLink> */}
            </NavItem>
            {/* <NavbarSearch /> */}
            {isMobile && <img src={keyIcon} alt="keyIcon" onClick={toggleHandler} className="me-1 header-icon-width"/>}
            <Announcement />
            <NotificationDropdown />
            <UserDropdown />
        </ul>
    );
};
export default NavbarUser;
